import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import { StudyPlanListFilters } from './api';
import { SearchFiltersLoader } from './hooks/SearchFiltersLoader';
import { StudyPlansListContainer } from './parts/Program/StudyPlansListContainer';
import { Filters, SearchFilters } from './parts/SearchFilters';

export function NonStructuredStudyPlans() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );
  const [filters, setFilters] = useState<Filters>({
    name: null,
    code: null,
    school: null,
    academicLevel: null,
    modality: null,
  });

  const apiFilters = useMemo<StudyPlanListFilters>(() => {
    return {
      name: filters.name || undefined,
      code: filters.code || undefined,
      schoolId: filters.school?.value as number | undefined,
      academicLevelId: filters.academicLevel?.value as number | undefined,
      modalityId: filters.modality?.value as number | undefined,
    };
  }, [filters]);

  const handleFiltersChange = (filterValues: Filters) => {
    setFilters(filterValues);
  };

  return (
    <div className="mx-3">
      <Card className="p-4 mt-2">
        <h2 className="text-primary fs-20 fw-700 mb-4 text-uppercase">
          {t('title')}
        </h2>
        <SearchFiltersLoader fetchImmediately>
          <SearchFilters onFiltersChange={handleFiltersChange} />
        </SearchFiltersLoader>

        <StudyPlansListContainer filters={apiFilters} />
      </Card>
    </div>
  );
}
